import {connect} from "react-redux";
import * as CoursesActions from '../../store/actions/coursesActions';
import SortableChapters from '../../components/AdminPanel/SortableChapters';

const mapStateToProps = (state) => ({
    ...state.courses
});

const mapDispatchToProps = (dispatch) => ({
    showModalDelete: (id, token) => {
        dispatch(CoursesActions.showModalDeletePart(id, token));
    },
    showModalDeleteCourse: (id) => {
        // add lgic
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SortableChapters);


// WEBPACK FOOTER //
// ./src/containers/AdminPanel/SortableChaptersContainer.js